import { requiredRule, ValidateOptions } from '@.hooks';
import { ProductTypesData } from '@/Components/Pages/Data/ProductTypes/Action/types';

export const validateOptions: ValidateOptions<ProductTypesData> = {
    name: {
        type: 'lingual',
        required: requiredRule,
    },
};
